import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const maxInlineSize = '800px';
export const GuideIllustration = props => {
  const {
    isBelowTablet
  } = useViewport();
  return /*#__PURE__*/_jsx(Illustration, Object.assign({}, props, {
    inlineSize: isBelowTablet ? '100px' : '150px',
    padding: "200"
  }));
};
export const GuideMediaBody = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MediaBody, Object.assign({
    maxInlineSize: maxInlineSize
  }, props, {
    children: children
  }));
};
export const ImageTextDisplay = ({
  text,
  image
}) => {
  const {
    isBelowTablet
  } = useViewport();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: isBelowTablet ? 'column-reverse' : 'row',
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(View, {
      children: text
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      inlineSize: `calc(100% - ${maxInlineSize})`,
      minInlineSize: "150px",
      children: image
    })]
  });
};